/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_View_MonthlyInputs */

const en_directory_launch_view_monthly = /** @type {(inputs: Directory_Launch_View_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View monthly launches →`)
};

const zh_directory_launch_view_monthly = /** @type {(inputs: Directory_Launch_View_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看月度榜单 →`)
};

/**
* | output |
* | --- |
* | "View monthly launches →" |
*
* @param {Directory_Launch_View_MonthlyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_view_monthly = /** @type {((inputs?: Directory_Launch_View_MonthlyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_View_MonthlyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_view_monthly(inputs)
	return zh_directory_launch_view_monthly(inputs)
});
export { directory_launch_view_monthly as "directory.launch.view_monthly" }